import React from 'react';
import './ChatSidebar.css';

const ChatSidebar = ({ friends, lastMessages, onClose, onChatSelect }) => {
  // Always sort friends by latest message timestamp descending (newest first)
  const sortedFriends = [...friends].sort((a, b) => {
    const aMsg = lastMessages[a._id];
    const bMsg = lastMessages[b._id];

    // Ensure createdAt is present and valid for sorting
    const getTime = (msg) => {
      if (!msg) return 0;
      // Prefer createdAt, fallback to time, else 0
      if (msg.createdAt) {
        // Handles both ISO string and Date objects
        return new Date(msg.createdAt).getTime() || 0;
      }
      if (msg.time) {
        return new Date(msg.time).getTime() || 0;
      }
      return 0;
    };

    const aTime = getTime(aMsg);
    const bTime = getTime(bMsg);

    // Descending: Most recent (biggest time) first
    return bTime - aTime;
  });

  return (
    <>
      {/* Overlay to close sidebar when clicking outside */}
      <div className="chat-sidebar-overlay" onClick={onClose}></div>
      
      {/* Sidebar */}
      <div className="chat-sidebar">
        {/* Header */}
        <div className="chat-sidebar-header">
          <h3 className="chat-sidebar-title">Messages</h3>
          <button className="chat-sidebar-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        
        {/* Friends List */}
        <div className="chat-sidebar-content">
          {sortedFriends.length === 0 ? (
            <div className="chat-sidebar-empty">
              <div className="chat-sidebar-empty-icon">💬</div>
              <p>No conversations yet</p>
              <span>Start chatting with your friends!</span>
            </div>
          ) : (
            <div className="chat-sidebar-list">
              {sortedFriends.map((friend) => (
                <div
                  key={friend._id}
                  className="chat-sidebar-item"
                  onClick={() => onChatSelect(friend._id)}
                >
                  <div className="chat-sidebar-avatar">
                    {friend.username ? friend.username[0].toUpperCase() : 'U'}
                  </div>
                  <div className="chat-sidebar-info">
                    <div className="chat-sidebar-name">{friend.username}</div>
                    <div className="chat-sidebar-last-message">
                      {lastMessages[friend._id] ? (
                        <span className={lastMessages[friend._id].isMine ? 'my-message' : 'their-message'}>
                          {lastMessages[friend._id].isMine && 'You: '}
                          {lastMessages[friend._id].text}
                        </span>
                      ) : (
                        <span className="no-messages">Start a conversation</span>
                      )}
                    </div>
                  </div>
                  <div className="chat-sidebar-chevron">
                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none">
                      <path d="M1 1L6 6L1 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChatSidebar;